module.exports = __webpack_public_path__ + "img/nz.9e547785.svg";